export default __webpack_public_path__ + "static/media/mobilebackground.08e30c29.svg";